import React, { useCallback } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

// Components
import Switch from '@material-ui/core/Switch';
import { Typography } from '@material-ui/core';

interface Props {
  value: boolean;
  onChange: (key: string, value: any) => void;
}

function GroupEmail({ onChange, value }: Props) {
  const classes = useStyles();
  const enabled = !!value;

  const handleChangeEnabled = useCallback(
    function(e, isEnabled) {
      onChange('client.settings.groupEmail.enabled', isEnabled);
    },
    [onChange],
  );

  return (
    <>
      <Typography variant="h6">Email</Typography>
      <div className={classes.content}>
        <Typography variant="subtitle2">Allow users to send a group email</Typography>
        <Switch
          id="group-email"
          inputProps={{ 'aria-label': 'group email switch' }}
          onChange={handleChangeEnabled}
          checked={enabled}
        />
      </div>
    </>
  );
}
const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default GroupEmail;
